import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const addEmailEndpoint = ApiEndpoints.emailManagement.Create;

const defaultForm = {
  form_type: "",
  to: "",
  cc: "",
  bcc: "",
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const parseEmailLines = (fieldName, value, required = false) => {
  const textValue = String(value || "");
  if (textValue.includes(",")) {
    return { error: `${fieldName} emails must be added line by line. Comma separated emails are not permitted.`, emails: [] };
  }
  const emails = textValue.split(/\r?\n/).filter((email) => email !== "");
  if (required && !emails.length) return { error: `At least one ${fieldName} email is required.`, emails: [] };
  const emailWithSpace = emails.find((email) => email !== email.trim() || /\s/.test(email));
  if (emailWithSpace) return { error: `Extra spaces are not valid in ${fieldName} email: ${emailWithSpace}`, emails: [] };
  const invalidEmail = emails.find((email) => !emailRegex.test(email));
  if (invalidEmail) return { error: `Invalid ${fieldName} email address: ${invalidEmail}`, emails: [] };
  return { error: "", emails };
};

const validateForm = (form) => {
  if (!form.form_type.trim()) return "Form Type is required.";
  return parseEmailLines("To", form.to, true).error ||
    parseEmailLines("CC", form.cc).error ||
    parseEmailLines("BCC", form.bcc).error;
};

const buildPayload = (form) => ({
  form_type: form.form_type.trim(),
  to: parseEmailLines("To", form.to, true).emails,
  cc: parseEmailLines("CC", form.cc).emails,
  bcc: parseEmailLines("BCC", form.bcc).emails,
});

export default function AddEmailManagement() {
  const navigate = useNavigate();
  const [form, setForm] = useState(defaultForm);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((current) => ({ ...current, [name]: value }));
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationError = validateForm(form);
    if (validationError) return toast.error(validationError);
    try {
      const response = await ApiRequest("POST", addEmailEndpoint, buildPayload(form));
      if (response.error) return toast.error(response.message);
      toast.success(response.message);
      navigate("/email-management");
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Unable to create email management record.");
    }
  };
  const pagename = { name: "Email Management", user: "Admin", innerpage: "Email Management / Add Emails" };
  return <>
    <AdminHeader pagename={pagename} />
    <div className="add-content-page">
      <form id="emailManagementAdd" onSubmit={handleSubmit}>
        <div className="add-content-wrap">
          <div className="row">
            <div className="col-lg-12"><div className="add-page-inputs"><div className="add-page-sections">Add Emails</div></div></div>
            <div className="col-lg-6"><div className="add-page-inputs">
              <div className="label-wrap-add"><label>Form Type<small>*</small></label></div>
              <input name="form_type" value={form.form_type} type="text" className="form-control" placeholder="contact_form" onChange={handleInputChange} required />
            </div></div>
            <div className="col-lg-12"><div className="add-page-inputs">
              <div className="label-wrap-add"><label>To Emails<small>*</small></label></div>
              <textarea name="to" value={form.to} className="form-control" style={{ height: "150px" }} placeholder={"sales@example.com\nsupport@example.com"} onChange={handleInputChange} required />
            </div></div>
            <div className="col-lg-6"><div className="add-page-inputs">
              <div className="label-wrap-add"><label>CC Emails</label></div>
              <textarea name="cc" value={form.cc} className="form-control" style={{ height: "150px" }} placeholder={"cc@example.com\nmanager@example.com"} onChange={handleInputChange} />
            </div></div>
            <div className="col-lg-6"><div className="add-page-inputs">
              <div className="label-wrap-add"><label>BCC Emails</label></div>
              <textarea name="bcc" value={form.bcc} className="form-control" style={{ height: "150px" }} placeholder={"bcc@example.com\narchive@example.com"} onChange={handleInputChange} />
            </div></div>
          </div>
        </div>
      </form>
      <button type="submit" form="emailManagementAdd" className="default-btn">publish <span></span></button>
    </div>
  </>;
}
